// extracted by mini-css-extract-plugin
export default {"loginGrid":"PageNotFound_loginGrid__Qv9qk","loader":"PageNotFound_loader__UHHGN","error":"PageNotFound_error__OeVdC"};